import { Icon, Text, HStack, VStack, VStackTypes } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import React, { useCallback } from 'react';
import { Pressable } from 'react-native';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import { useWithValueVisibility } from '../../../../../../../hooks/useWithValueVisibility';
import { getFlex } from '../utils';

import { InvestmentStrategyItemTypes } from './types';

const defaultVStackProps: VStackTypes.Props = {
  space: Spacing['stack.quarck'],
  flex: 1,
};

export const InvestmentStrategyItemTablet: React.FC<InvestmentStrategyItemTypes.Props> = ({
  item,
}) => {
  const withValueVisibility = useWithValueVisibility();
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpand = useCallback(() => {
    setExpanded((state) => !state);
  }, []);

  return (
    <TableContent
      direction="row"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}
      flexWrap="wrap">
      <TableContentItemColumn flex={getFlex(0)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Data</Text>
          <Text>{withValueVisibility(item.partitionDateNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Cliente</Text>
          <Text>{withValueVisibility(item.customerNameNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Conta de custódia</Text>
          <Text>{withValueVisibility(item.customerCustodyAccountNumberNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Conta sinacor</Text>
          <Text>{withValueVisibility(item.customerAccountNumberNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Total PL</Text>
          <Text>{withValueVisibility(item.plValueNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex="none">
        <Pressable onPress={toggleExpand}>
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size="xs" />
        </Pressable>
      </TableContentItemColumn>
      {expanded && (
        <VStack
          padding={Spacing['inset.xs']}
          space={Spacing['stack.nano']}
          marginTop={Spacing['inline.xxxs']}
          borderRadius={BoxRadius.sm}
          backgroundColor={Color.background}
          width="100%">
          <HStack>
            <VStack {...defaultVStackProps}>
              <Text variant="bold">Estado</Text>
              <Text>{withValueVisibility(item.stateNormalized)}</Text>
            </VStack>
            <VStack {...defaultVStackProps}>
              <Text variant="bold">Nome do assessor</Text>
              <Text>{withValueVisibility(item.advisorNameNormalized)}</Text>
            </VStack>
            <VStack {...defaultVStackProps}>
              <Text variant="bold">Filial</Text>
              <Text>{withValueVisibility(item.branchNameNormalized)}</Text>
            </VStack>
            <VStack {...defaultVStackProps}>
              <Text variant="bold">Classe</Text>
              <Text>{withValueVisibility(item.suitabilityNormalized)}</Text>
            </VStack>
            <VStack {...defaultVStackProps}>
              <Text variant="bold">Telefone</Text>
              <Text>{withValueVisibility(item.phoneNormalized)}</Text>
            </VStack>
            <VStack {...defaultVStackProps}>
              <Text variant="bold">Situação</Text>
              <Text>{withValueVisibility(item.statusNormalized)}</Text>
            </VStack>
          </HStack>
        </VStack>
      )}
    </TableContent>
  );
};
